<template>
  <div class="mx-auto">
    <b-row>
      <b-col xxs="12">
        <div class="row mt-5">
          <div class="col">
            <router-link to="/">
              <img src="@/assets/img/logo.png" height="80" class="mb-3" />
            </router-link>
            <h1 class="font-weight-bold mega-text m-0 p-0">
              Register, It's Free
            </h1>

            <div class="alert alert-danger mt-3">
              If you are joining an existing organisation on Tajmie, Do not
              register. Request an admin to create a user account for you in the
              system.
            </div>

            <div class="card my-5">
              <div class="card-body">
                <form-base
                  :submit-status="submitStatus"
                  action="Sign Up"
                  :errors="errors"
                  :loading="loading"
                  v-on:handleSubmit="handleSubmit"
                >
                  <template v-slot:fields>
                    <h3>Your Details:</h3>
                    <form-group label="Full Name" :required="true">
                      <input
                        ref="name"
                        type="text"
                        @blur="$v.user.name.$touch"
                        class="form-control"
                        :class="{ 'is-invalid': $v.user.name.$error }"
                        v-model="user.name"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.user.name.required"
                      >
                        Please enter full name
                      </div>
                    </form-group>

                    <form-group label="Your Email" :required="true">
                      <input
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': $v.user.email.$error }"
                        v-model="user.email"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.user.email.required"
                      >
                        Please enter email address
                      </div>
                      <div class="invalid-feedback" v-if="!$v.user.email.email">
                        invalid email address
                      </div>
                    </form-group>

                    <form-group label="Password" :required="true">
                      <input
                        type="password"
                        class="form-control"
                        :class="{ 'is-invalid': $v.user.password.$error }"
                        v-model="user.password"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.user.password.minLength"
                      >
                        Please enter password with a minimun of 6 characters
                      </div>
                    </form-group>

                    <h3 class="mt-5">Organisation Details</h3>

                    <form-group label="Organisation Name" :required="true">
                      <input
                        type="text"
                        @blur="$v.organisation.organisation_name.$touch"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.organisation.organisation_name.$error,
                        }"
                        v-model="organisation.organisation_name"
                      />

                      <div
                        class="invalid-feedback"
                        v-if="!$v.organisation.organisation_name.required"
                      >
                        Please enter organisation name
                      </div>
                    </form-group>

                    <form-group label="Registration / NPO Number">
                      <input
                        type="text"
                        class="form-control"
                        v-model="organisation.registration_number"
                      />
                    </form-group>

                    <form-group label="Contact Number" :required="true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="organisation.contact_number"
                        @blur="$v.organisation.contact_number.$touch"
                        :class="{
                          'is-invalid': $v.organisation.contact_number.$error,
                        }"
                      />
                    </form-group>

                    <form-group label="Email Address" :required="true">
                      <input
                        type="email"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.organisation.organisation_email.$error,
                        }"
                        v-model="organisation.organisation_email"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.organisation.organisation_email.required"
                      >
                        Please enter email address
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.organisation.organisation_email.email"
                      >
                        invalid email address
                      </div>
                    </form-group>

                    <form-group label="Physical Address">
                      <textarea-autosize
                        class="form-control"
                        v-model="organisation.physical_address"
                      />
                    </form-group>
                  </template>
                </form-base>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

     <div class="row mt-5">
        <div class="col text-center mb-5">
          <p>
            For the pleasure of Allah, By
            <a href="https://niftybit.co.za">NiftyBit</a>
          </p>

          <br><br>
          <small>
            <router-link :to="{name:'legal', hash: '#terms' }">Terms & Conditions</router-link> |
            <router-link :to="{name:'legal', hash: '#disclaimer' }">Disclaimer</router-link> |
            <router-link :to="{name:'legal', hash: '#privacy' }">Privacy Policy</router-link> 
          </small>
        </div>
      </div>
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import userRepo from "@/api/repos/userRepo";
import { mapActions } from "vuex";

export default {
  components: {
    formBase,
    formGroup,
  },

  data() {
    return {
      user: {},
      organisation: {
        code: "001",
      },
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  mounted() {
    this.$refs.name.focus();
  },

  validations: {
    user: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
    organisation: {
      organisation_name: {
        required,
      },
      organisation_email: {
        required,
      },

      contact_number: {
        required,
      },
    },
  },

  methods: {
    ...mapActions("user", ["doCheckAuth"]),

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await userRepo.guestSignUp({ ...this.user, ...this.organisation });

          await this.doCheckAuth({
            email: this.user.email,
            password: this.user.password,
            remember: 1,
          });

          this.$root.$bvToast.toast("Signed In", {
            title: "Success",
            autoHideDelay: 1500,
            variant: "success",
          });

          if (this.$route.params.nextUrl != null) {
            this.$router.push(this.$route.params.nextUrl);
          } else {
            this.$router.push({ name: "home" });
          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
